// Cursor pagination — the WIRE shapes for every cursor-paged list (INFRA-02:
// keyset-only; OFFSET is banned). Browser-safe: fe builds these query strings
// and api validators parse them, so the contract lives here. The worker-side
// mechanics (encodeCursor/decodeCursor/keysetPage) stay in @erp/platform/db,
// which re-exports CursorQuery so worker code keeps one import.
import { z } from "zod";

/** The wire query for cursor-paged lists. Limit cap is 100 — the kernel's 1000 was a law violation. */
export const CursorQuery = z.object({
  limit: z.coerce.number().int().min(1).max(100).catch(25),
  cursor: z.string().optional(),
});
export type CursorQuery = z.infer<typeof CursorQuery>;

/** Cursor-shaped list meta — replaces the legacy offset `{page,limit,total,pages}` (ADR-001 §7.2 divergence). */
export const CursorMeta = z.object({
  /** Opaque cursor for the next page; null when this page is the last. */
  nextCursor: z.string().nullable(),
});
export type CursorMeta = z.infer<typeof CursorMeta>;
